<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <rect x="4" y="5" width="16" height="14" rx="2" stroke="currentColor" stroke-width="1.75" />
  <circle cx="9" cy="10" r="1.5" stroke="currentColor" stroke-width="1.75" />
  <path
    d="M5 17L9.5 12.5L13 16L16 13L19 17"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
